import { render } from "./package_bronze.vue?vue&type=template&id=29582b58"
const script = {}
script.render = render

export default script